if (!customElements.get('ms-cart-suggestions')) {
  class MsCartSuggestions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', this.handleSubmit);
      if (this.dataset.url) this.loadRecommendations();
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.handleSubmit);
      this.request?.abort();
    }

    async loadRecommendations() {
      this.request = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.request.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('.ms-cart-suggestions__content');
        if (content?.querySelector('.ms-cart-suggestion') && this.isConnected && !this.busy) {
          this.querySelector('.ms-cart-suggestions__content').replaceChildren(...content.childNodes);
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.recommendationsUnavailable = 'true';
      }
    }

    handleSubmit = async (event) => {
      const form = event.target.closest('.ms-cart-suggestion__form');
      if (!form) return;
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      if (this.busy || drawer.querySelector('cart-items.pointer-events-none')) return;
      this.busy = true;
      drawer.dataset.cartBusy = 'true';
      const cartItems = drawer.querySelector('cart-items');
      if (cartItems) cartItems.inert = true;
      const checkout = drawer.querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = true;
      const buttons = this.querySelectorAll('button');
      buttons.forEach((button) => { button.disabled = true; });
      const errors = this.querySelector('.ms-cart-suggestions__error');
      errors.hidden = true;
      const data = new FormData(form);
      data.append('sections', drawer.getSectionsToRender().map((section) => section.section).join(','));
      data.append('sections_url', window.location.pathname);
      let added = false;
      try {
        const response = await fetch(theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || theme.strings.cartError);
        added = true;
        await drawer.renderContents(result, false);
        drawer.querySelector('.drawer__close-btn')?.focus();
        document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { variantId: Number(data.get('id')) } }));
      } catch (error) {
        if (added) {
          window.location.assign(theme.routes.cart || form.action.replace(/\/add(?:\.js)?$/, ''));
          return;
        }
        errors.textContent = error.message || theme.strings.cartError;
        errors.hidden = false;
      } finally {
        this.busy = false;
        delete drawer.dataset.cartBusy;
        if (cartItems) cartItems.inert = false;
        if (checkout) checkout.disabled = false;
        buttons.forEach((button) => { button.disabled = false; });
      }
    };
  }
  customElements.define('ms-cart-suggestions', MsCartSuggestions);
}
